/**
 * 数据库索引清理助手 - 对接 FastAPI 后端
 * 后端默认地址可在 .env 中配置 VUE_APP_INDEX_CLEANUP_API
 */
import axios from 'axios'

const baseURL = process.env.VUE_APP_INDEX_CLEANUP_API || 'http://127.0.0.1:8011'

const service = axios.create({
  baseURL,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json'
  }
})

service.interceptors.response.use(
  response => response.data,
  error => {
    const msg = error.response?.data?.detail || error.response?.data?.error || error.message
    return Promise.reject(new Error(msg))
  }
)

/**
 * 请求体：snake_case，与后端 ScanRequest / CleanRequest 一致
 */
function toSnakeBody(tableId, columnId, limitPreview = 20) {
  return {
    table_id: String(tableId ?? '').trim(),
    column_id: String(columnId ?? '').trim(),
    ...(limitPreview !== undefined && { limit_preview: limitPreview })
  }
}

/**
 * 扫描重复记录
 * @param {Object} params - { tableId: string, columnId: string, limitPreview?: number }
 * @returns {Promise<{ status: string, data?: { total_duplicates: number, preview: Array } }>}
 */
export function scanDuplicates(params) {
  const body = toSnakeBody(params.tableId, params.columnId, params.limitPreview ?? 20)
  return service.post('/scan_duplicates', body)
}

/**
 * 清理重复记录并创建唯一索引（后端路径为 clean_duplicates）
 * @param {Object} params - { tableId: string, columnId: string }
 * @returns {Promise<{ status: string, data?: { deleted_count: number, unique_index: string } }>}
 */
export function cleanDuplicates(params) {
  const { table_id, column_id } = toSnakeBody(params.tableId, params.columnId)
  return service.post('/cleanup_and_create_unique_index', { table_id, column_id })
}
